import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import { uploadImage } from "../unit/UploadImage";
import { $t } from "../plugins/i18n";
import { ElMessage, ElLoading } from "element-plus";
import dsteem from "../unit/DsteemUtil";
export default {
  components: {},
  data: function data() {
    return {
      loginData: null,
      saveLoad: false,
      profile: {
        profile_image: "",
        location: "",
        version: 2,
        cover_image: "",
        name: "",
        about: "",
        website: "",
        likeid: "",
        signature: "",
        blogPostRewards: 0,
        commentPostRewards: 0
      },
      blogPostRewards: [0, 1],
      commentPostRewards: [0, 1]
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _account$blogPostRewa, _account$commentPostR;

        var account;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loginData = extractLoginData();

                if (!_this.loginData) {
                  _this.$router.push({
                    path: "/"
                  });
                }

                _context.next = 4;
                return getAccount(_this.loginData[0]);

              case 4:
                account = _context.sent;
                _this.profile.profile_image = account.profile_image;
                _this.profile.location = account.location;
                _this.profile.cover_image = account.cover_image;
                _this.profile.name = account.name;
                _this.profile.about = account.about;
                _this.profile.website = account.website;
                _this.profile.likeid = account.likeid;
                _this.profile.signature = account.signature;
                _this.profile.blogPostRewards = (_account$blogPostRewa = account.blogPostRewards) !== null && _account$blogPostRewa !== void 0 ? _account$blogPostRewa : 0;
                _this.profile.commentPostRewards = (_account$commentPostR = account.commentPostRewards) !== null && _account$commentPostR !== void 0 ? _account$commentPostR : 0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgAdd: function imgAdd(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _file;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _file = params.file;
                _context2.next = 3;
                return uploadImage(_file);

              case 3:
                _this2.profile.profile_image = _context2.sent;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isJPG = file.type === "image/jpeg" || file.type === "image/png";
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        //this.$message.error("上传头像图片只能是 JPG 格式!");
        ElMessage.error(this.$t("error.uploadImageTypeError"));
      }

      if (!isLt2M) {
        //this.$message.error("上传头像图片大小不能超过 2MB!");
        ElMessage.error(this.$t("error.uploadImageSizeError"));
      }

      return isJPG && isLt2M;
    },
    onSave: function onSave() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.saveLoad = true;
                _context3.next = 3;
                return dsteem.accountUpdate2(_this3.profile);

              case 3:
                _this3.saveLoad = false;

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    go: function go(src) {
      window.location.href = src;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.loadAccount();

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};